import React from 'react'

// components
import {
  CCol,
  CFormLabel,
  CFormSwitch
} from '@coreui/react-pro'

const FormSwitchInput = ({
  id,
  name,
  colSize,
  className,
  inputLabel,
  label,
  value,
  handleSwitch,
  feedbackInvalid,
  invalid,
  disabled
}) => {
  return (
    <CCol lg={colSize} className={className}>
      {inputLabel && (
        <CFormLabel className='fs-6 fs-md-3'>
          {inputLabel}
        </CFormLabel>
      )}
      <CFormSwitch
        id={id}
        name={name}
        label={label ? label : value?.toString()?.toLowerCase() === 'true' ? 'Yes' : 'No'}
        valid={value}
        defaultChecked={value}
        onChange={(e) => handleSwitch(e)}
        feedbackInvalid={feedbackInvalid}
        invalid={invalid}
        disabled={disabled}
        checked={value}
        className='fs-6 fs-md-3'
      />
    </CCol>
  )
}

export default FormSwitchInput